import styles from './DesktopNavigation.module.scss';
import { MetaHeaderDesktop } from '../MetaHeader/MetaHeader';
import MainNavigation from './components/MainNavigation/MainNavigation';
import SubNavigation from './components/SubNavigation/SubNavigation';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

const DesktopNavigation = ({
  languageSwitch,
  layoutStructure,
  mainMenu,
  metaMenu,
  rootLevel,
}) => {
  const [subItems, setSubItems] = useState([]);
  const [verticalScrollPosition, setVerticalScrollPosition] = useState(
    window.scrollY,
  );
  const [isUpScrolled, setIsUpScrolled] = useState(false);

  useEffect(() => {
    // when scrolling, only show full navigation when scrolling up
    const handleNavigation = ({ currentTarget }) => {
      const window = currentTarget;

      setIsUpScrolled(verticalScrollPosition > window.scrollY);
      setVerticalScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleNavigation);

    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [verticalScrollPosition]);

  useEffect(() => {
    const currentMainItemIndex = mainMenu.findIndex(item => item.isActive);
    // set sub items depending on selected index for main navigation
    if (mainMenu[currentMainItemIndex]?.children) {
      setSubItems(mainMenu[currentMainItemIndex]?.children);
      return;
    }

    if (currentMainItemIndex) {
      setSubItems(mainMenu[0]?.children);
    }
  }, []);

  return (
    <>
      <MetaHeaderDesktop
        languageSwitch={languageSwitch}
        metaMenu={metaMenu}
        rootLevel={rootLevel}
      />
      <div
        className={classNames(styles.container, {
          [styles.isUpScrolled]: isUpScrolled,
          [styles.noSubItems]: subItems?.length === 0,
        })}
      >
        <MainNavigation
          isReduced={false}
          layoutStructure={layoutStructure}
          mainMenu={mainMenu}
          noSubMenu={subItems?.length === 0}
          rootLevel={rootLevel}
        />
        {subItems?.length !== 0 && <SubNavigation items={subItems} />}
      </div>
    </>
  );
};

export default DesktopNavigation;
